import React from 'react';
import * as cls from './how-it-works.module.css';
// import { Link } from 'react-router-dom';
import { IMG_PATH /*, ROUTES_PATHS  */ } from '../../../constants';
import { Section } from '../../../ui/components/section';
import { Typography } from '../../../ui/components/typography';
// import { Button } from '../../../ui/components/button';

const itemsFirst = [
  {
    title: 'Smart meter data (15/30/60-min):',
    text: 'launch "smart-bill" insights instantly - no hardware.',
  },
  {
    title: 'Real-time via CAD/dongles:',
    text: 'enable peak-time shifting and demand-response.',
  },
  {
    title: 'Voltaware home energy monitor (optional):',
    text: 'unlock premium sub-second detail, solar-ready.',
  },
];

const itemsSecond = [
  {
    title: 'Disaggregation:',
    text: 'AI translates usage into appliance-level insights.',
  },
  {
    title: 'Dashboards for utilities:',
    text: 'monitor customer behaviour, ROI, and CO₂ savings.',
  },
  {
    title: 'APIs as a Service:',
    text: 'embed insights into portals, apps, and billing journeys.',
  },
  {
    title: 'White-label apps:',
    text: 'launch fast under your own brand.',
  },
];

export const HowItWorks = () => {
  return (
    <>
      <Section classNameRoot={cls.section}>
        <Typography tag="h2">How It Works</Typography>
        <Typography>
          From raw usage data to personalised engagement - in just 2 steps.
        </Typography>

        <div className={cls.item__wrapper}>
          <div>
            <Typography className={cls.item__circle__title}>
              <span>01</span> Collect the Right Data
            </Typography>
            <ol className={cls.list}>
              {itemsFirst.map((item, index) => (
                <li key={index}>
                  <Typography>{item.title}</Typography>
                  <Typography>{item.text}</Typography>
                </li>
              ))}
            </ol>
            <img
              alt="Collecting data from smart meters, CADs and optional home energy monitor"
              className={cls['img--mobile']}
              src={`${IMG_PATH}/utilities/collecting-data-for-utilities.png`}
            />
            <Typography>
              <span>Voltaware delivers</span> Engagement-as-a-Service for
              utilities by combining data aggregation, Al analytics, and
              customer engagement tools into one streamlined service.
            </Typography>
          </div>
          <img
            alt="Collecting data from smart meters, CADs and optional home energy monitor"
            className={cls['img--desktop']}
            src={`${IMG_PATH}/utilities/collecting-data-for-utilities.png`}
          />
        </div>

        <div className={cls.item__wrapper}>
          <img
            alt="AI disaggregation turning meter data into appliance-level insights and APIs for utilities"
            className={cls['img--desktop']}
            src={`${IMG_PATH}/utilities/AI-brain-turns-data-into-engagement.png`}
          />
          <div>
            <Typography className={cls.item__circle__title}>
              <span>02</span> Turn Data into Engagement
            </Typography>
            <ol className={cls.list}>
              {itemsSecond.map((item, index) => (
                <li key={index}>
                  <Typography>{item.title}</Typography>
                  <Typography>{item.text}</Typography>
                </li>
              ))}
            </ol>
            <img
              alt="AI disaggregation turning meter data into appliance-level insights and APIs for utilities"
              className={cls['img--mobile']}
              src={`${IMG_PATH}/utilities/AI-brain-turns-data-into-engagement.png`}
            />
            <Typography>
              Get actionable energy insights where you need them - via
              dashboards, APIs, or branded apps.
            </Typography>
          </div>
        </div>
      </Section>

      {/* <Section backgroundContrast classNameRoot={cls['as-a-service__wrapper']}>
        <Typography className={cls['as-a-service']}>
          This is not another IT stack -{' '}
          <span>
            it’s utility customer engagement
            <br />
            <em>software delivered as a service</em>.
          </span>
        </Typography>

        <Link to={ROUTES_PATHS.REQUEST_A_DEMO}>
          <Button>Request Demo</Button>
        </Link>
      </Section>*/}
    </>
  );
};
